import { EmojiCategoryData, EmojiData, EmojiProvider } from './EmojiModel';
import { TwemojiProvider } from './twitter/Twemoji';

const store = {
    rebuild: true,
    providers: [new TwemojiProvider()] as EmojiProvider[],
    codeDict: {} as { [code: string]: string },
    emojiIndex: {} as { [id: string]: EmojiData },
    emojiList: [] as EmojiData[],
    categoryList: [] as EmojiCategoryData[],
};

// At some point we discovered some emoji that aren't correct and were removed.  This is a map
// //of the old codes to the new codes for any emoji that were removed.
const remaps = {
    '002a': '002a-20e3',
    '0023': '0023-20e3',
    '0030': '0030-20e3',
    '0031': '0031-20e3',
    '0032': '0032-20e3',
    '0033': '0033-20e3',
    '0034': '0034-20e3',
    '0035': '0035-20e3',
    '0036': '0036-20e3',
    '0037': '0037-20e3',
    '0038': '0038-20e3',
    '0039': '0039-20e3',
};

export const EmojiStore = {

    register: (ep: EmojiProvider): void => {
        store.providers.push(ep);
        store.rebuild = true;
    },

    getEmoji: (): Readonly<EmojiData[]> => {
        checkRebuild();
        return store.emojiList;
    },

    getCategories: (): Readonly<EmojiCategoryData[]> => {
        checkRebuild();
        return store.categoryList;
    },

    find: (idOrCodeOrValue: string): EmojiData => {
        checkRebuild();
        idOrCodeOrValue = remaps[idOrCodeOrValue] || idOrCodeOrValue;
        idOrCodeOrValue = store.codeDict[idOrCodeOrValue] || idOrCodeOrValue;
        return (store.emojiIndex[idOrCodeOrValue] || null);
    },

};

function checkRebuild() {

    if (!store.rebuild) return;

    store.emojiList = store.providers
        .map(x => x.getEmoji()).reduce((t, x) => t.concat(x), []).slice(0).sort((a, b) => a.order - b.order);
    store.categoryList = store.providers
        .map(x => x.getCategories()).reduce((t, x) => t.concat(x), []).slice(0).sort((a, b) => a.order - b.order);

    store.codeDict = {};
    store.emojiIndex = {};

    for (const e of store.emojiList) {
        store.emojiIndex[e.id] = e;
        store.emojiIndex[e.value] = e;
        for (const c of e.codes) {
            store.codeDict[c] = e.id;
        }
    }

    store.rebuild = false;
}
